export default function initTabs() {
	const tabLinks = document.querySelectorAll('.tablinks');
	const tabContents = document.querySelectorAll('.tabcontent');

	if (!tabLinks.length) return;

	function openTab(link) {
		tabContents.forEach((tab) => {
			tab.style.display = 'none';
		});

		tabLinks.forEach((item) => {
			item.classList.remove('active');
		});

		const target = document.getElementById(link.dataset.tab);

		if (target) {
			target.style.display = 'block';
		}

		link.classList.add('active');
	}

	tabLinks.forEach((link) => {
		link.addEventListener('click', () => {
			openTab(link);
		});
	});

	document.getElementById('defaultOpen')?.click();
}